require('./bootstrap');
require('./themeColors');
require('./functions');

//Plugins
require('./slider');

import Vue from 'vue';

const app = new Vue({
    el: '#app',
});
